/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { get, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import InputField from '../../Common/InputField';
import SelectDropdown from '../.././Common/SelectDropdown';
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from '../interceptor/interceptor';
import FullScreenLoader from '../Loader/FullScreenLoader';
import {
  ADD_NOTES_DETAILS,
  DOCUMENT_UPLOAD,
  EDIT_NOTES_DETAILS,
  GET_NOTES,
  DOCUMENT_DELETE,
  S3_SIGNED_URL,
} from '../../apiConst';
import {
  notesFields,
  dataEntryNotesFields,
  ttdNoteFields,
} from '../../Fields/notesFields';
import { useLocation, useNavigate } from 'react-router';
import NotesDisplay from './NotesDisplay';
import UploadField from '../../Common/UploadField';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Grid,
} from '@mui/material';
import CustomModal from '../../Common/CustomModal';

const TicketCharter = ({ ticketNo, isView, tabValue, role, loc, ttdReqNo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [editNote, setEditNote] = useState(false);
  const [allNotes, setAllNotes] = useState([]);
  const [keyValue, setKeyValue] = useState('');
  const [ticket, setTicket] = useState(ticketNo || ttdReqNo);
  const [notesData, setNotesData] = useState({});
  const [signedUrls, setSignedUrls] = useState([]);
  const fields = notesFields;

  const navigate = useNavigate();
  // const params = useParams();
  // const location = useLocation();

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    setTicket(ticketNo);
    if (!modal) {
      fetchListData();
    }
  }, [modal]);

  const fetchListData = (pg = 1, size = 50, search = '', searchKey = null) => {
    setIsLoading(true);

    if (ttdReqNo?.length > 0) {
      let payload = {
        filter: {
          ttdReqNo: ttdReqNo,
        },
        sortOrder: -1,
        page: pg,
        pageSize: size,
      };

      postRequest(GET_NOTES, payload)
        .then((res) => {
          console.log('res', res);
          const { result, totalCount } = res.data;
          console.log('result', result);
          setAllNotes(result);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else if (ticketNo?.length > 0) {
      let payload = {
        filter: {
          ticketNo: ticketNo,
        },
        sortOrder: -1,
        page: pg,
        pageSize: size,
      };

      postRequest(GET_NOTES, payload)
        .then((res) => {
          console.log('res', res);
          const { result, totalCount } = res.data;
          console.log('result', result);
          setAllNotes(result);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (allNotes?.length > 0) {
      getSignedUrl(allNotes);
    }
  }, [allNotes]);

  const getSignedUrl = async (allNotes) => {
    const keysArray = [];
    for (const note of allNotes) {
      if (note?.attachment && note?.attachment?.length > 0) {
        for (const attachment of note?.attachment) {
          keysArray.push(attachment?.key);
        }
      }
    }

    if (keysArray?.length > 0) {
      try {
        const response = await postRequest(`${S3_SIGNED_URL}`, {
          keys: keysArray,
        });
        const signedUrls = response?.data;
        setSignedUrls(signedUrls);
      } catch (error) {
        console.error('Error fetching signed URLs:', error);
      }
    }
  };

  const onSubmit = (data) => {
    if (loc === '/AddGms') {
      const payload = {
        comment: data?.note,
        attachment: [{ url: data?.uploadFile, key: data?.uploadFileName }],
        ticketNo: ticketNo,
        status: data?.status,
      };
      let url = '';
      if (editNote) {
        const payload = {
          comment: data.note,
          attachment: [
            { url: data?.uploadFile, key: data?.uploadFileName },
          ] || [
            {
              url: data?.attachment[0]?.url,
              key: data?.attachment[0]?.key,
            },
          ],
          ticketNo: ticketNo,
          noteId: data.noteId,
          status: data.Status,
        };

        url = putRequest(`${EDIT_NOTES_DETAILS}`, payload);
      } else {
        url = postRequest(`${ADD_NOTES_DETAILS}`, payload);
      }
      url
        .then((res) => {
          setIsLoading(false);
          reset({ note: '', uploadFile: '', uploadFileName: '' });
          setEditNote(false);
          setModal(false);
          fetchListData();
        })
        .catch(() => {
          setIsLoading(false);
          setModal(false);
        });
    } else if (loc === '/ttd-calendar/add-edit/ttd-request') {
      const payload = {
        comment: data?.note,
        attachment: [{ url: data?.uploadFile, key: data?.uploadFileName }],
        ttdReqNo: ttdReqNo,
        status: data?.status,
      };
      let url = '';
      if (editNote) {
        const payload = {
          comment: data.note,
          attachment: [
            { url: data?.uploadFile, key: data?.uploadFileName },
          ] || [
            {
              url: data?.attachment[0]?.url,
              key: data?.attachment[0]?.key,
            },
          ],
          ttdReqNo: ttdReqNo,
          noteId: data.noteId,
          status: data.Status,
        };

        url = putRequest(`${EDIT_NOTES_DETAILS}`, payload);
      } else {
        url = postRequest(`${ADD_NOTES_DETAILS}`, payload);
      }
      url
        .then((res) => {
          setIsLoading(false);
          reset({ note: '', uploadFile: '', uploadFileName: '' });
          setEditNote(false);
          setModal(false);
          fetchListData();
        })
        .catch(() => {
          setIsLoading(false);
          setModal(false);
        });
    }
  };

  const onEditNote = (e, note) => {
    console.log('note: ', note);
    reset(note);
    setValue('note', note.comment);
    setValue('uploadFile', note.attachment[0]);
    setValue('uploadFileName', note.attachment[0]);
    setValue('status', note.status);
    setEditNote(true);
    setModal(true);

    // reset(note);
  };

  const onUpload = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    setValue('uploadFile', '');
    setValue('uploadFileName', '');

    postRequest(`${DOCUMENT_UPLOAD}`, formData, {
      'Content-Type': 'multipart/form-data',
    })
      .then((res) => {
        console.log('fileurl:--->', res);
        setValue('uploadFile', res.data.data[0].url);
        setValue('uploadFileName', res.data.data[0].key);
        setKeyValue(res.data.data[0].key);
        setTimeout(() => {
          setIsLoading(false);
        }, 100);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const onRemoveFile = async (e, keyValue) => {
    console.log('🚀 ~ onRemoveFile ~ keyValue:', keyValue);
    console.log('removed cliked', e);
    const res = await deleteRequest(`${DOCUMENT_DELETE}${keyValue}`);
    try {
      console.log('🚀 ~ onRemoveFile ~ res:', res);
      if (res) {
        toast.success(res?.data?.message);
        setValue('uploadFileName', '');
        setValue('uploadFile', '');
        reset({ uploadFile: '', uploadFileName: '' });
        fetchListData();
      }
    } catch (error) {
      console.log('🚀 ~ onRemoveFile ~ error:', error);
    }
  };

  const openModal = () => {
    setModal(!modal);
  };

  const pressCloseButton = () => {
    setModal(!modal);
    reset({ note: '', uploadFile: '', uploadFileName: '', status: '' });
    editNote && setEditNote(false);
  };

  const ModalBody = () => {
    return (
      <>
        {isLoading && <FullScreenLoader />}
        <form className="w-full flex justify-center items-center flex-col p-5">
          {role === 'Grievance-Data-Entry-Operator' || loc === '/AddGms' ? (
            <div className="w-full grid md:grid-cols-1 gap-6">
              {dataEntryNotesFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  disabled,
                  options,
                } = field;
                return (
                  <div className="flex flex-col w-full" key={fieldName}>
                    <label className="block text-gray-800 font-bold mb-3 pr-4">
                      {fieldTitle}
                    </label>
                    <div className="w-full flex items-center">
                      <div className="w-full">
                        {fieldType === 'upload' && (
                          <UploadField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            onChange={onUpload}
                            onRemoveFile={onRemoveFile}
                            valueClassName="flex m-2 items-center"
                            value={getValues('uploadFileName')}
                            placeholder={fieldTitle}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-center">
                <Button
                  type="button"
                  variant="contained"
                  className="mt-4 px-6 py-2 rounded-md bg-success-700 text-white transition duration-150 hover:bg-success-600"
                  onClick={handleSubmit(onSubmit)}
                >
                  {editNote ? 'Edit' : 'Submit'}
                </Button>
              </div>
            </div>
          ) : loc === '/ttd-calendar/add-edit/ttd-request' ? (
            <div className="w-full grid md:grid-cols-1 gap-6">
              {ttdNoteFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  disabled,
                  options,
                } = field;
                return (
                  <div className="flex flex-col w-full" key={fieldName}>
                    <label className="block text-gray-800 font-bold mb-3 pr-4">
                      {fieldTitle}
                    </label>
                    <div className="w-full flex items-center">
                      <div className="w-full">
                        {fieldType === 'upload' ? (
                          <UploadField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            onChange={onUpload}
                            onRemoveFile={onRemoveFile}
                            valueClassName="flex m-2 items-center"
                            value={getValues('uploadFileName')}
                            placeholder={fieldTitle}
                          />
                        ) : fieldType === 'select' ? (
                          <>
                            <SelectDropdown
                              fieldName={fieldName}
                              options={options}
                              register={register}
                              validationObj={{
                                required: 'Please Select Note Type',
                              }}
                              errors={errors}
                              disabled={disabled}
                            />
                          </>
                        ) : (
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            disabled={disabled}
                            placeholder={fieldTitle}
                            className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring focus:ring-primary-300"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-center">
                <Button
                  type="button"
                  variant="contained"
                  className="mt-4 px-6 py-2 rounded-md bg-success-700 text-white transition duration-150 hover:bg-success-600"
                  onClick={handleSubmit(onSubmit)}
                >
                  {editNote ? 'Edit' : 'Submit'}
                </Button>
              </div>
            </div>
          ) : (
            <div className="w-full grid md:grid-cols-1 gap-6">
              {fields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  disabled,
                  options,
                } = field;
                return (
                  <div className="flex flex-col w-full" key={fieldName}>
                    <label className="block text-gray-800 font-bold mb-3 pr-4">
                      {fieldTitle}
                    </label>
                    <div className="w-full flex items-center">
                      <div className="w-full">
                        {fieldType === 'upload' ? (
                          <UploadField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            onChange={onUpload}
                            onRemoveFile={onRemoveFile}
                            valueClassName="flex m-2 items-center"
                            value={getValues('uploadFileName')}
                            placeholder={fieldTitle}
                          />
                        ) : fieldType === 'select' ? (
                          <>
                            <SelectDropdown
                              fieldName={fieldName}
                              options={options}
                              register={register}
                              validationObj={{
                                required: 'Please Select Note Type',
                              }}
                              errors={errors}
                              disabled={disabled}
                            />
                          </>
                        ) : (
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            disabled={disabled}
                            placeholder={fieldTitle}
                            className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring focus:ring-primary-300"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-center">
                <Button
                  type="button"
                  variant="contained"
                  className="mt-4 px-6 py-2 rounded-md bg-success-700 text-white transition duration-150 hover:bg-success-600"
                  onClick={handleSubmit(onSubmit)}
                >
                  {editNote ? 'Edit' : 'Submit'}
                </Button>
              </div>
            </div>
          )}
        </form>
      </>
    );
  };
  return (
    <Card className="p-4 mt-4">
      {isLoading && <FullScreenLoader />}
      <div className="flex flex-col lg:flex-row justify-between">
        <Typography className="text-2xl font-bold text-gray-700">
          {role === 'Grievance-Data-Entry-Operator' || loc === '/AddGms'
            ? 'Files'
            : 'Notes'}
        </Typography>

        {!isView && (
          <div className="m-4 mt-0">
            <Button
              type="button"
              onClick={() => openModal()}
              // color="primary"
              variant="contained"
              className="bg-blueBg hover:blueBg"
            >
              {role === 'Grievance-Data-Entry-Operator' || loc === '/AddGms'
                ? 'Attach Files'
                : 'Add Note'}
            </Button>
          </div>
        )}
      </div>
      <CustomModal
        modal={modal}
        body={<ModalBody />}
        heading="Note"
        pressCloseButton={pressCloseButton}
      />
      {allNotes?.length > 0 && (
        <NotesDisplay
          notesData={allNotes}
          onEditNote={onEditNote}
          isView={isView}
          signedUrls={signedUrls}
          fetchNotes={fetchListData}
        />
      )}
    </Card>
  );
};

export default TicketCharter;
